import FormSelectField from "./FormSelectField";
import React from "react";
import {SelectProps} from "@mui/material/Select/Select";
import {FormikProps} from "formik";
import {TFunction} from "i18next";
import {LANGUAGE_CODES} from "../../enums";
import MenuItem from "@mui/material/MenuItem";
import {get} from "lodash";
import {getTranslation, TranslationContext} from "../../utils/getTranslationKey";
import {Grid} from "@mui/material";
import {GridTypeMap} from "@mui/material/Grid/Grid";

export type LanguageSelectProps = SelectProps & {
    fieldName: string;
    label: string;
    form: FormikProps<any>;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    t: TFunction;
};

const LanguageSelect = ({
    fieldName,
    label,
    form,
    t,
    isGridItem = false,
    gridProps = {xs: 6},
    ...rest
}: LanguageSelectProps) => {
    const getSelect = () => (
        <>
            <FormSelectField
                fieldName={fieldName}
                form={form}
                label={label}
                labelId={`label-${fieldName}`}
                value={get(form?.values, fieldName)?.toUpperCase()}
                {...rest}
            >
                {Object.keys(LANGUAGE_CODES).map((languageEntry, index) => {
                    return (
                        <MenuItem value={languageEntry} key={`lang_${fieldName}_${index}`}>
                            {getTranslation({
                                context: TranslationContext.LANGUAGE,
                                value: languageEntry,
                                t,
                            })}
                        </MenuItem>
                    );
                })}
            </FormSelectField>
        </>
    );
    return isGridItem ? (
        <Grid item {...gridProps}>
            {getSelect()}
        </Grid>
    ) : (
        getSelect()
    );
};
export default LanguageSelect;
